import React from 'react';
import MapView from './components/MapView';
import './App.css';

function App() {
  return (
    <div className="App">
      <MapView/>
    </div>
  );
}

export default App;
